module.exports = __webpack_public_path__ + "img/profil.f39d1f4f.svg";